"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findCountryObjectInCountriesList = exports.isSCAEnabled = exports.changeNumberFormatForNonSCARegions = void 0;
/**
 * Loops through the phonesList and if SCA is disabled, it will rreplace the masked subscriber with the national number. By default it is internationally formatted
 *
 * @param phonesList - List of phone objects having forrmatted phones in national and international format
 * @param isSCAEnabled - Boolean value which tells if SCA is enabled or not.
 * @returns modifiedPhonesList
 */
function changeNumberFormatForNonSCARegions(phonesList, isSCAEnabled) {
    var modifiedPhonesList = phonesList;
    if (!isSCAEnabled) {
        modifiedPhonesList = phonesList.map(function (item) {
            item.maskedSubscriberNumber = item.maskedSubscriberNationalNumber;
            return item;
        });
    }
    return modifiedPhonesList;
}
exports.changeNumberFormatForNonSCARegions = changeNumberFormatForNonSCARegions;
function isSCAEnabled(features) {
    return features.internationalPhones;
}
exports.isSCAEnabled = isSCAEnabled;
function findCountryObjectInCountriesList(countriesList, id) {
    var countryObject = countriesList.find(function (obj) { return obj.countryCode === id; });
    return countryObject;
}
exports.findCountryObjectInCountriesList = findCountryObjectInCountriesList;
